import React, { useState } from "react";
import { CustomerViewDetailsProps } from "./customer-view-details.props";
import CustomerViewDetailsView from "./customer-view-details-view/customer-view-details-view";
// import CustomerViewDetailsEdit from "./customer-view-details-edit/customer-view-details-edit";
import "./customer-view-details.scss";

const CustomerViewDetails: React.FC<CustomerViewDetailsProps> = (props: any) => {
  const {
    customerDetails,
    selectedCustomerId,
    setLoading,
    viewEditOpen,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    uploadedImageFile,
    setUploadedImageFile,
    setRemoveImage,
    removeImage,
    fetchCustomerDetails,
    onCustomerNameUpdate,
    resetImageUpload,
    handleFormSubmitError,
    disableCustomerStatus,
    permissions,
    isMobile,
  } = props;
  return (
    <div className="customer-list-view-details-edit-view">
      <div className="customer-list-view-details-view">
        <CustomerViewDetailsView
          customerDetails={customerDetails}
          setLoading={setLoading}
          selectedCustomerId={selectedCustomerId}
          viewEditOpen={viewEditOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          setViewFullInfoOpen={setViewFullInfoOpen}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          uploadedImageFile={uploadedImageFile}
          setUploadedImageFile={setUploadedImageFile}
          setRemoveImage={setRemoveImage}
          removeImage={removeImage}
          fetchCustomerDetails={fetchCustomerDetails}
          onCustomerNameUpdate={onCustomerNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          disableCustomerStatus={disableCustomerStatus}
          permissions={permissions}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default CustomerViewDetails;
